import Model, { type HasMany, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { BeniMarketCompositionMarket } from 'lumen/models';

export default class BeniMarketComposition extends Model {
  [Type] = 'benchmark-insight/market-composition' as const;

  @hasMany('benchmark-insight/market-composition-market', {
    async: false,
    inverse: null,
  })
  declare markets: HasMany<BeniMarketCompositionMarket>;
}
